import { Button, Divider, Flex, Form, Input, Modal } from 'antd'
import { useUnit } from 'effector-react'
import { useModalRequestRejectSeo } from 'src/pages/budget/budgetRequests/hooks'
import {
  closeModalRequestsRejectSeo,
  rejectApproveRequestsFx,
  submitRequestsApproveReject,
} from 'src/pages/budget/budgetRequests/model'
import { LinkifiedText, UiText } from 'src/pages/budget/components'
import { REQUIRED_FIELD } from 'src/pages/budget/const'

type RejectFormValues = {
  comment: string
}

export const ModalRequestsRejectSeo = () => {
  const loadingButton = useUnit(rejectApproveRequestsFx.pending)
  const [form] = Form.useForm<RejectFormValues>()
  const modalRequestsRejectSeo = useModalRequestRejectSeo()

  if (!modalRequestsRejectSeo) return null

  const { items } = modalRequestsRejectSeo
  const { id, description } = items[0]
  const ids = items.map(({ id }) => id)
  const open = Boolean(modalRequestsRejectSeo)

  const handleCancel = () => {
    form.resetFields()
    closeModalRequestsRejectSeo()
  }

  const handleOk = async () => {
    try {
      const { comment } = await form.validateFields()

      submitRequestsApproveReject({ id, comment })
      handleCancel()
    } catch (error) {
      // ошибка валидации формы
    }
  }

  return (
    <Modal
      title={
        <div style={{ fontSize: 20 }}>
          Отклонить {ids.length > 1 ? 'заявки' : 'заявку'}
        </div>
      }
      centered
      wrapClassName="ant_modal"
      width={500}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={handleCancel}
      footer={
        <Flex gap={8}>
          <Button size="large" style={{ flex: 1 }} onClick={handleCancel}>
            Отменить
          </Button>
          <Button
            size="large"
            loading={loadingButton}
            color="volcano"
            variant="solid"
            style={{ flex: 1 }}
            onClick={handleOk}
          >
            Отклонить: SEO
          </Button>
        </Flex>
      }
    >
      <Divider />

      <UiText size={18}>
        Вы уверены, что хотите отклонить {ids.length > 1 ? 'заявки' : 'заявку'}{' '}
        <UiText size={18} strong>
          {' '}
          № {ids.join(', ')} <LinkifiedText text={description} />
        </UiText>{' '}
        как <strong>SEO</strong>? Это действие нельзя будет отменить.
      </UiText>

      <Form form={form} layout="vertical">
        <Form.Item
          name="comment"
          rules={[
            {
              required: true,
              whitespace: true,
              message: REQUIRED_FIELD,
            },
          ]}
          style={{ marginTop: 24 }}
        >
          <Input.TextArea
            rows={3}
            placeholder="Здесь вы можете написать причину отклонения или комментарий"
          />
        </Form.Item>
      </Form>

      <Divider />
    </Modal>
  )
}
